import { z } from 'zod'

// Standard API Error Response Schema
export const ApiErrorSchema = z.object({
  error: z.string(),
  code: z.string().optional(),
  details: z.array(z.object({
    path: z.array(z.union([z.string(), z.number()])),
    message: z.string(),
    code: z.string().optional()
  })).optional()
})

// Success Response Schema for operations that return simple success messages
export const ApiSuccessSchema = z.object({
  success: z.boolean(),
  message: z.string().optional()
})

// Common HTTP Status Code Schemas
export const UnauthorizedErrorSchema = z.object({
  error: z.literal('Unauthorized'),
  code: z.literal('AUTH_ERROR')
})

export const ForbiddenErrorSchema = z.object({
  error: z.literal('Forbidden'),
  code: z.literal('FORBIDDEN')
})

export const NotFoundErrorSchema = z.object({
  error: z.string(),
  code: z.literal('NOT_FOUND')
})

export const ValidationErrorSchema = z.object({
  error: z.literal('Validation failed'),
  code: z.literal('VALIDATION_ERROR'),
  details: z.array(z.object({
    path: z.array(z.union([z.string(), z.number()])),
    message: z.string()
  }))
})

// Export TypeScript types
export type ApiError = z.infer<typeof ApiErrorSchema>
export type ApiSuccess = z.infer<typeof ApiSuccessSchema>
export type UnauthorizedError = z.infer<typeof UnauthorizedErrorSchema>
export type ForbiddenError = z.infer<typeof ForbiddenErrorSchema>
export type NotFoundError = z.infer<typeof NotFoundErrorSchema>
export type ValidationError = z.infer<typeof ValidationErrorSchema>

// Helper function to create validation error details from Zod errors
export const formatZodError = (error: z.ZodError): ValidationError['details'] => {
  return error.issues.map(issue => ({
    path: issue.path,
    message: issue.message
  }))
} 